// Player Set Actions
export const SET_LOADING = "SET_LOADING";
export const SET_ERROR = "SET_ERROR";
export const SET_ALERT = "SET_ALERT";
export const SET_CONTRACT_INSTANCE = "SET_CONTRACT_INSTANCE";
export const SET_WALLET = "SET_WALLET";
export const SET_WALLET_MODAL = "SET_WALLET_MODAL";
export const SET_IS_AUTH = "SET_IS_AUTH";
export const SET_TRADE_TOKEN = "SET_TRADE_TOKEN";
export const SET_TOKEN_LIST = "SET_TOKEN_LIST";
export const SET_TOKEN_BALANCE = "SET_TOKEN_BALANCE";
export const SET_DAI_BALANCE = "SET_DAI_BALANCE";
export const SET_WALLET_TX_TYPE = "SET_WALLET_TX_TYPE";
export const SET_TRADE_TX_SIDE = "SET_TRADE_TX_SIDE";
export const SET_ORDER_TX_TYPE = "SET_ORDER_TX_TYPE";